import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const setUserProfileVerifier = async ({ uid, hasVerified, verifier }) => {
	try {
		if (uid === verifier.uid) {
			return Promise.reject(errorOfType(errorTypes.INVALIDOBJECT, uid, 'cannot verify yourself'))
		}
		const ref = firestore.collection('userProfiles').doc(uid).collection('verifiers').doc(verifier.uid)
		return (hasVerified ? ref.set(verifier) : ref.delete())
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}
export default setUserProfileVerifier



// WEBPACK FOOTER //
// ./src/dataservices/setUserProfileVerifier.js